// Combined legend + filter chips for the unified calendar. Each type is a
// toggle (aria-pressed) with a color dot AND a text label — status is never
// communicated by color alone. Only types present in the current feed (or
// explicitly listed) are offered.
import React from 'react';
import { Check } from 'lucide-react';
import { CALENDAR_TYPE_META, type CalendarEventType } from '@/lib/calendarApi';

interface Props {
  availableTypes: CalendarEventType[];
  hiddenTypes: Set<string>;
  onToggle: (type: CalendarEventType) => void;
}

export const CalendarFilterLegend: React.FC<Props> = ({ availableTypes, hiddenTypes, onToggle }) => (
  <div className="flex flex-wrap gap-1.5" role="group" aria-label="Calendar filters">
    {availableTypes.map((tp) => {
      const meta = CALENDAR_TYPE_META[tp];
      const active = !hiddenTypes.has(tp);
      return (
        <button
          key={tp}
          type="button"
          aria-pressed={active}
          onClick={() => onToggle(tp)}
          className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full border text-xs font-medium transition-colors ${
            active
              ? 'border-transparent ' + meta.chip
              : 'border-border bg-card text-muted-foreground opacity-60'
          }`}
          title={active ? `Hide ${meta.label}` : `Show ${meta.label}`}
        >
          <span className={`w-2 h-2 rounded-full ${meta.dot}`} aria-hidden />
          {meta.label}
          {active && <Check className="w-3 h-3" aria-hidden />}
        </button>
      );
    })}
  </div>
);

export default CalendarFilterLegend;
